<template>
	<div class="userList column-me" v-loading="loading">
		<div class="card-view column-me" style="display: block;">
			<el-page-header @back="goBack" :content="boxTitle"></el-page-header>
			<el-alert class="margin-top20 font-bold" title="素材基础信息" effect="dark" type="success" :closable="false"></el-alert>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>素材分类：</div>
				<div class="width500">
					<el-cascader
						:options="classTableData"
						:props="{ checkStrictly: true , emitPath:false }"
						clearable 
						v-model="this.dataInfo.spe_sub_id"
					></el-cascader>
					
				</div>
				<div class="left-title"><span class="red-star">*</span>排序：</div>
				<div class="width150">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="dataInfo.sort"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>素材名称：</div>
				<div class="width800">
					<el-input placeholder="请输入" style="width: 100%;" clearable v-model="dataInfo.title"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20" v-if="this.dataInfo.image == ''">
			  <div class="left-title"><span class="red-star">*</span>素材封面：</div>
			  <el-upload action="" :show-file-list="false"
			             :before-upload="beforeAvatarUpload" accept=".jpg,.jpeg,.png" :auto-upload="true"
			             :http-request="uploadFile">
						 <el-button type="primary">上传</el-button>
			  </el-upload>
			</div>
			<div class="row-me row-center margin-top20" v-if="this.dataInfo.image != ''">
				<div class="left-title"><span class="red-star">*</span>素材封面：</div>
				<div class="width300">
					<el-image 
						v-if="!this.$method.isEmpty(dataInfo.image)" 
						style="width: 150px; height: auto" 
						:src="dataInfo.image" 
						:fit="contain" 
						:preview-src-list="[dataInfo.image]">
					</el-image>
					
				</div>
				<div class="width100 margin-left30">
					<el-button @click="deleteImage" type="danger">删除</el-button>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"></div>
				<div class="width800">
					<el-input placeholder="素材封面地址" style="width: 100%;" clearable v-model="this.dataInfo.image"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20" v-if="this.dataInfo.link != ''">
				<div class="left-title"><span class="red-star">*</span>视频素材：</div>
				<div class="upload-container width300">
					<video ref="videoPlayer" :key="videoKey" @loadeddata="videoLoadedData" width="300" height="auto" controls>
						<source :src="this.dataInfo.link"  type="video/mp4">
					</video>
				</div>
				<div class="width100 margin-left30">
					<el-button @click="deleteVideo" type="danger">删除</el-button>
				</div>
				
			</div>
			<div class="row-me row-center margin-top20" v-else>
				<div class="left-title"><span class="red-star">*</span>视频素材：</div>
				<div class="upload-container width300">
					<el-upload 
						class="upload-demo"
						ref="upload" 
						accept=".mp4" 
						drag 
						action="" 
						:auto-upload="false"  
						:on-change="beforeVideoUpload" 
						:limit="1" 
						:on-exceed="handleExceed">
						<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
					</el-upload>
					<el-button v-if="uploadVideoAliossBtn" style="margin-top: 20px;" type="primary" @click="uploadVideo">上传到服务器</el-button>
					<el-alert
						v-if="this.uploadeErrBox"
					    title="上传错误：阿里云oss上传地址链接超时"
					    type="error"
					    effect="dark">
					</el-alert>
				</div>
				<div class="width200 margin-left30">
					<el-progress type="circle" v-if="uploading" :percentage="uploadPercentage"></el-progress>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"></div>
				<div class="width800">
					<el-input placeholder="视频地址" style="width: 100%;" clearable v-model="dataInfo.link"></el-input>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>视频时长：</div>
				<div class="width600">
					<el-input-number v-model="dataInfo.duration" :min="0" :max="100000000">
					      <template #suffix>
					        <span>秒</span>
					      </template>
					    </el-input-number>
				</div>
			</div>
			<div class="row-me row-center margin-top20">
				<div class="left-title"><span class="red-star">*</span>素材简介：</div>
				<div class="width800">
					<div style="border: 1px solid #ccc" id="editor">
					      <Toolbar
					        style="border-bottom: 1px solid #ccc"
					        :editor="editorRef"
					        :defaultConfig="toolbarConfig"
					        :mode="mode"
					      />
					      <Editor
					        style="height: 300px; overflow-y: hidden;"
					        v-model="this.dataInfo.detail"
					        :defaultConfig="editorConfig"
					        :mode="mode"
					        @onCreated="handleCreated"
							@onChange="handleChange"
					      />
					    </div>
				</div>
			</div>
			<el-alert class="margin-top20 font-bold" title="课后练习添加" effect="dark" type="success" :closable="false"></el-alert>
			<div class="row-me row-center">
					<el-table :data="afterClassData" stripe="true" size="medium" style="width: 100%" height="500">
						<el-table-column prop="title" label="试卷标题" width="300" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="type" label="试卷类型" width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag type="success" effect="dark" v-if="scope.row.type == 1">练习试卷</el-tag>
								<!-- <el-tag type="danger" effect="dark" v-if="scope.row.type == 2">考试试卷</el-tag> -->
							</template>
						</el-table-column>
						<el-table-column prop="TcSpecialSubInfo.name" label="试卷分类"  width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="single_num" label="单选题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="multiple_num" label="多选题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="judgment_num" label="判断题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="blank_num" label="填空题数量" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="brief_num" label="简答题数量" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="method" label="组题方式" width="150" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag type="success" effect="dark" v-if="scope.row.method == 1">手动组题</el-tag>
								<el-tag type="danger" effect="dark" v-if="scope.row.method == 2">自动组题</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="add_time" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
					</el-table>
			</div>
			<div class="row-me row-center margin-top20">
				<el-button type="danger" @click="afterClassSelect(1)"> 课后练习选择</el-button>
				<el-button @click="afterClassSelectClear">全部删除</el-button>
			</div>
			<el-alert class="margin-top20 font-bold" title="试题测验添加" effect="dark" type="success" :closable="false"></el-alert>
			<div class="row-me row-center">
					<el-table :data="examTestData" stripe="true" size="medium" style="width: 100%" height="500">
						<el-table-column prop="title" label="试卷标题" width="300" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="type" label="试卷类型" width="100" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag type="success" effect="dark" v-if="scope.row.type == 1">练习试卷</el-tag>
								<el-tag type="danger" effect="dark" v-if="scope.row.type == 2">考试试卷</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="TcSpecialSubInfo.name" label="试卷分类"  width="200" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="single_num" label="单选题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="multiple_num" label="多选题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="judgment_num" label="判断题数量"  width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="blank_num" label="填空题数量" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="brief_num" label="简答题数量" width="150" align="center" show-overflow-tooltip></el-table-column>
						<el-table-column prop="method" label="组题方式" width="150" align="center" show-overflow-tooltip>
							<template #default="scope">
								<el-tag type="success" effect="dark" v-if="scope.row.method == 1">手动组题</el-tag>
								<el-tag type="danger" effect="dark" v-if="scope.row.method == 2">自动组题</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="add_time" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
					</el-table>
			</div>
			<div class="row-me row-center margin-top20">
				<el-button type="danger" @click="examTestSelect(2)"> 试题测验选择</el-button>
				<el-button @click="examTestSelectClear">全部删除</el-button>
			</div>
			<div class="row-me flex-end1 margin-top50">
				<el-button @click="goBack()">取消</el-button>
				<el-button type="primary" @click="addClickSave">确定</el-button>
			</div>
		</div>
	</div>
	<!-- 课后练习信息添加界面 -->
	<el-dialog title="课后练习选择"
		class="height90Per"
		v-model="afterClassBox" 
		:show-close="false" 
		:close-on-click-modal="false" 
		:close-on-press-escape="false" 
		width="80%" 
		top="5vh" 
		:destroy-on-close="true">
				<div class="flex1 overflow-auto">
					<div class="row-me row-center margin-top20">
						<div class="left-title"><span class="red-star">*</span>练习题分类：</div>
						<div class="width500">
							<el-cascader
								:options="afterClassTableData"
								:props="{ checkStrictly: true , emitPath:false }"
								clearable 
								v-model="this.selectSpeSubId"
								@change="afterSelectSpeSubId(1,this.selectSpeSubId)"
							></el-cascader>
							
						</div>
					</div>
					<el-divider></el-divider>
					<div class="row-me row-center margin-top20">
						<el-table 
						:data="afterClassSelectData" 
						ref="afterClassMultipleTable" 
						@select="afterClassHandleSelect"
						@select-all="afterClassHandleSelectAll"
						reserve-selection
						:row-key="afterClassGetRowKey"
						stripe="true" 
						size="medium" 
						style="width: 100%" 
						height="100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="title" label="试卷标题" width="300" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="type" label="试卷类型" width="100" align="center" show-overflow-tooltip>
								<template #default="scope">
									<el-tag type="success" effect="dark" v-if="scope.row.type == 1">练习试卷</el-tag>
									<el-tag type="danger" effect="dark" v-if="scope.row.type == 2">考试试卷</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="TcSpecialSubInfo.name" label="试卷分类"  width="200" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="single_num" label="单选题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="multiple_num" label="多选题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="judgment_num" label="判断题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="blank_num" label="填空题数量" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="brief_num" label="简答题数量" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="method" label="组题方式" width="100" align="center" show-overflow-tooltip>
								<template #default="scope">
									<el-tag type="success" effect="dark" v-if="scope.row.method == 1">手动组题</el-tag>
									<el-tag type="danger" effect="dark" v-if="scope.row.method == 2">自动组题</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="add_time" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="afterClassCurrentChange" background :page-size="afterClassLimit" :current-page.sync="afterClassPageNo"
						 layout="total, prev, pager, next, jumper" :total="afterClassTotal">
					</el-pagination>
				</div>
				<div class="row-me flex-end1 margin-top50">
					<el-button @click="afterClassBoxClosed">取消</el-button>
					<el-button type="primary" @click="afterClassBoxClosed">选择完毕</el-button>
				</div>
	</el-dialog>
	<!-- 课后练习信息添加界面 -->
	<el-dialog title="试题测验选择"
		class="height90Per"
		v-model="examTestBox" 
		:show-close="false" 
		:close-on-click-modal="false" 
		:close-on-press-escape="false" 
		width="80%" 
		top="5vh" 
		:destroy-on-close="true">
				<div class="flex1 overflow-auto">
					<div class="row-me row-center margin-top20">
						<div class="left-title"><span class="red-star">*</span>试题分类：</div>
						<div class="width500">
							<el-cascader
								:options="afterClassTableData"
								:props="{ checkStrictly: true , emitPath:false }"
								clearable 
								v-model="this.selectSpeSubId"
								@change="examTestSelectSpeSubId(2,this.selectSpeSubId)"
							></el-cascader>
							
						</div>
					</div>
					<el-divider></el-divider>
					<div class="row-me row-center margin-top20">
						<el-table 
						:data="examTestSelectData" 
						ref="examTestMultipleTable" 
						@select="examTestHandleSelect"
						@select-all="examTestHandleSelectAll"
						reserve-selection
						:row-key="examTestGetRowKey"
						stripe="true" 
						size="medium" 
						style="width: 100%" 
						height="100%">
							<el-table-column type="selection" width="55"></el-table-column>
							<el-table-column prop="title" label="试卷标题" width="300" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="type" label="试卷类型" width="100" align="center" show-overflow-tooltip>
								<template #default="scope">
									<el-tag type="success" effect="dark" v-if="scope.row.type == 1">练习试卷</el-tag>
									<el-tag type="danger" effect="dark" v-if="scope.row.type == 2">考试试卷</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="TcSpecialSubInfo.name" label="试卷分类"  width="200" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="single_num" label="单选题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="multiple_num" label="多选题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="judgment_num" label="判断题数量"  width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="blank_num" label="填空题数量" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="brief_num" label="简答题数量" width="100" align="center" show-overflow-tooltip></el-table-column>
							<el-table-column prop="method" label="组题方式" width="100" align="center" show-overflow-tooltip>
								<template #default="scope">
									<el-tag type="success" effect="dark" v-if="scope.row.method == 1">手动组题</el-tag>
									<el-tag type="danger" effect="dark" v-if="scope.row.method == 2">自动组题</el-tag>
								</template>
							</el-table-column>
							<el-table-column prop="add_time" label="创建时间" align="center" show-overflow-tooltip></el-table-column>
						</el-table>
					</div>
				</div>
				<div class="margin-top20">
					<el-pagination @current-change="examTestCurrentChange" background :page-size="examTestLimit" :current-page.sync="examTestPageNo"
						 layout="total, prev, pager, next, jumper" :total="examTestTotal">
					</el-pagination>
				</div>
				<div class="row-me flex-end1 margin-top50">
					<el-button @click="examTestBoxClosed">取消</el-button>
					<el-button type="primary" @click="examTestBoxClosed">选择完毕</el-button>
				</div>
	</el-dialog>
</template>
<script>
import OSS from 'ali-oss'
import { inject,provide } from 'vue'
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
export default {
	components: {Editor,Toolbar},
	name: 'MyEditor',
	data() {
		return {
			id:'',
			loading:true,
			imgloading:false,
			classTableData:[],
			afterClassTableData:[],
			examTestClassTableData:[],
			editorRef:null,
			dataInfo:{
				id: '',
				spe_sub_id: '',
				title: '',
				detail: '',
				link: '',
				duration: 0,
				image:'',
				sort:0
			},
			//=====课后练习，试题测验 分类id
			selectSpeSubId:0,
			//=====课后练习选择参数【开始】=====
			afterClassBox:false,	
			afterClassData:[],	//素材选中后的数据
			afterClassSelectData:[], //弹窗素材选择table数据
			afterClassPageNo:1,
			afterClassTotal:0,
			afterClassLimit:10,
			//=====试题测验选择参数【开始】=====
			examTestBox:false,
			examTestData:[],	//素材选中后的数据
			examTestSelectData:[], //弹窗素材选择table数据
			examTestPageNo:1,
			examTestTotal:0,
			examTestLimit:10,
			taskUrl:'http://video.chongfenlusvip.cn/',
			boxTitle:'',
			file:null,
			infoEditBox:false,
			infoAddBox:false,
			isVideoUpload:false,
			uploading:false,
			aliOssToken:null,
			uploadPercentage:0,
			uploadVideoAliossBtn:false,
		}
	},
	setup() {
        // 编辑器实例，必须用 shallowRef
        const editorRef = shallowRef()
        const toolbarConfig = {}
        const editorConfig = { 
			placeholder: '请输入内容...',
			MENU_CONF:{
				uploadImage:{
					server:sessionStorage.getItem('GlobalUploadUrl')+'/admin/uploadOss',
					fieldName: 'wangeditor-uploaded-image',
					headers: {
					    Accept: 'text/x-json',
						adminkey:sessionStorage.getItem('token')
					},
					meta: {
					    // 自定义请求的meta
					    'X-Test-Name': 'test'
					},
					multiple: false, // 是否支持多选文件
					maxFileSize: 5 * 1024 * 1024, // 最大支持文件大小 (5M) 单位为byte
					maxNumberOfFiles: 1, // 最大上传个数
					allowedFileTypes: ['image/*'],
					withCredentials: false,
					onSuccess: function (editor, result, xhr) {
						//console.log('上传成功', editor);
					    //console.log('上传成功', result);
					},
					onError: function (editor, err, xhr) {
					    console.log('上传失败', err);
					},
					customInsert(res, insertFn) {
						console.log(res);
						if(res.code == 200){
							const dataInfo = res.data;
							insertFn(dataInfo.url, dataInfo.alt, dataInfo.href)
						}else{
							//alert(res..message);
						}
						
					},
				}
			}
		}
		// 模拟 ajax 异步获取内容
		onMounted(() => {
			const editor = editorRef.value;
			//editor.config.uploadImgServer = '你的上传地址';
			//console.log(editor);
		})
        // 组件销毁时，也及时销毁编辑器
        onBeforeUnmount(() => {
			const editor = editorRef.value
			if (editor == null) return
			editor.destroy()
        })
        const handleCreated = (editor) => {
			editor.on('change', () => {
				const imgs = document.querySelectorAll('.w-e-image-container img'); // 获取所有图片元素
				imgs.forEach(img => {
					img.style.width = '100%'; // 设置宽度为100%
					img.style.height = 'auto'; // 保持图片宽高比
				});
			})
			editorRef.value = editor // 记录 editor 实例，重要！
			console.log(editor);
			console.log('====================');
        }
		
        return {
			editorRef,
			//valueHtml,
			mode: 'default', // 或 'simple'
			toolbarConfig,
			editorConfig,
			handleCreated,
        }
    },
	// 侦听器
	watch: {},
	// 计算属性
	computed: {
		Search() {
			return Search
		}
	},
	// html加载完成之前
	created() {
		this.getClassifyData();
	},
	// html加载完成后执行。
	mounted() {
		console.log(sessionStorage.getItem('GlobalUploadUrl'));
		this.id = this.$route.query.id;
		if(this.id == 0){
			this.boxTitle = '素材信息添加';
			this.loading = false;
		}else{
			this.boxTitle = '素材信息修改';
			this.getAddInfo();
		}
	},
	// 事件方法执行
	methods: {
		goBack() {
			this.$router.go(-1)
		},
		//列表分页
		handleCurrentChange(pageNo) {
			this.PageNo = pageNo
			this.getData()
		},
		//获取要修改的信息详情
		getAddInfo(){
			this.$post('/admin/specialTaskInfo',{id:this.id}).then((res) => {
				if (res) {
					this.dataInfo = res.data;
					this.afterClassData = res.data.afterClassData;
					this.examTestData = res.data.examTestData;
					this.loading = false;
					console.log(this.dataInfo);
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//新增信息保存
		addClickSave(){
			this.dataInfo.specialTaskData = this.specialTaskData;
			this.dataInfo.afterClassData = this.afterClassData;
			this.dataInfo.examTestData = this.examTestData;
			this.$post('/admin/specialTaskAdd', this.dataInfo).then((res) => {
				if (res) {
					this.goBack();
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//==============================================================简单上传【图片上传】【开始】===============================================================
		//上传图片验证
		beforeAvatarUpload(file) {
			let types = ['image/jpeg', 'image/jpg', 'image/png'];
			const isImage = types.includes(file.type);
			if (!isImage) {
				this.$message.error('上传图片只支持JPG、JPEG、PNG格式!')
				return false
			}
			const isLt5M = file.size / 1024 / 1024 < 5
			if (!isLt5M) {
				this.$message.error('上传图片不能超过5M')
				return false
			}
			return true
		},
		uploadFile(param) {
			this.imgloading = true;
			try {
				this.$uploadFileAliOss(param.file, res => {
					this.dataInfo.image = res;
					this.imgloading = false;
				}, err => {
					console.log(err)
				})
			} catch (error) {
				console.error('上传失败:', error);
			}
		},
		async deleteImage(){
			const url = new URL(this.dataInfo.image);
			const imageName = url.pathname.replace(/\//g, "");
			const deleteArr = [imageName];
			const delRess = await this.aliossDelete(deleteArr,1);
			if(delRess){
				this.$message.success('课程封面删除成功！')
			}else{
				
			}
		},
		//==============================================================简单上传【图片上传】【结束】===============================================================
		//==============================================================阿里云 ali-oss 【删除开始】===============================================================
		async aliossDelete(arr,type){
			const aliossToken = await this.$getAliOssToken();
			const client = new OSS({
				endpoint: aliossToken.endpoint,
				bucket: aliossToken.bucket,
				accessKeyId: aliossToken.accessKeyId,
				accessKeySecret: aliossToken.accessKeySecret
			});
			try {
				const result = await client.deleteMulti(arr, {quiet: true});
				if(result.res.status == 200){
					if(type == 1){
						this.dataInfo.image = '';	//删除图片
					}else{
						this.dataInfo.link = '';		//删除视频
					}
					return true;
				}else{
					this.$message.error('删除失败，请联系管理员！')
					console.log(result);
				}
			  } catch (error) {
				this.$message.error('删除失败，请联系管理员！')
				console.log(error);
				return false;
			  }
		},
		//==============================================================阿里云 ali-oss 【删除结束】===============================================================
		//上传视频验证=================================================大文件分片上传【视频上传】【开始】============================================================
		beforeVideoUpload(file) {
			//console.log(file);
			this.file = file.raw;
			//console.log(this.file);
			this.isVideoUpload = true;
			const types = ['video/mp4'];
			const isVideo = types.includes(this.file.type);
			if (!isVideo) {
				this.$message.error('上传视频只支持mp4格式!')
				return false
			}
			this.uploadVideoAliossBtn = true;
			return true
		},
		handleExceed(){
			this.$message.warning('只能上传一个文件');
		},
		async uploadVideo(param) {
			this.imgloading = true;
			this.uploading = true;
			this.isVideoUpload = false;
			try {
				const aliossToken = await this.$getAliOssToken();
				const client = new OSS({
			        endpoint: aliossToken.endpoint,
			        bucket: aliossToken.bucket,
			        accessKeyId: aliossToken.accessKeyId,
			        accessKeySecret: aliossToken.accessKeySecret
			    });
				const fileName = this.$generateFileName(this.file);
				//console.log(client);
				//console.log(this.file);
				//return;
			    const options = {
			        partSize: 1024 * 1024 * 5, // 分片大小为 5MB
			        parallel: 3, // 并发上传的分片数量
			        progress: (p, cpt, res) => {
			            this.uploadPercentage = Math.round(p * 100);
			        },
			    }; 
				const result = await client.multipartUpload(fileName, this.file, options);
				//console.log(result);
				this.$message.success('文件上传成功');
				this.imgloading = false;
				this.uploading = false;
				this.uploadVideoAliossBtn = false;
				this.dataInfo.link = this.taskUrl+result.name;
				this.dataInfo.etag = result.etag;
				this.videoKey += 1;
				this.uploadPercentage = 0;
			} catch (error) {
				console.error('上传失败:', error);
				this.uploadeErrBox = true;
			}
		},
		async deleteVideo(){
			const url = new URL(this.dataInfo.link);
			const videoName = url.pathname.replace(/\//g, "");
			const deleteArr = [videoName];
			const delRess = await this.aliossDelete(deleteArr,2);
			if(delRess){
				this.$message.success('视频素材删除成功！')
				this.dataInfo.duration = 0;
			}
		},
		videoLoadedData(){
			this.dataInfo.duration = Math.trunc(this.$refs.videoPlayer.duration);
		},
		//==============================================================大文件分片上传【视频上传】【结束】===============================================================
		//获取要修改的信息详情
		getDataInfo(){
			this.$post('/admin/specialInfo',{id:this.id}).then((res) => {
				if (res) {
					
					console.log(this.addInfo);
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//素材分类数据获取
		getClassifyData(){
			this.$post('/admin/specialSubList').then((res) => {
				if (res) {
					this.classTableData = res.data;
					this.afterClassTableData = res.data;
					this.examTestClassTableData = res.data;
				}
			}).catch((error) => {
				console.log(error)
			})
		},
		//========================================================课后练习&试题测验选择弹窗【开始】=======================================================
		//列表分页
		afterClassCurrentChange(pageNo){
		    this.afterClassPageNo = pageNo;
		    this.getAfterClassData(1,this.selectSpeSubId);
		},
		//记录选中的数据值
		//素材选择 单行 checkbox 选中出发
		afterClassHandleSelect(selection, row){
			this.afterClassData = selection;
		},
		afterClassGetRowKey(row){
			return row.id;
		},
		afterClassHandleSelectAll(selection){
			this.afterClassData = selection;
		},
		//试卷信息选择弹窗
		afterClassSelect(type){
			this.afterClassBox = true;
			this.getAfterClassData(type,this.selectSpeSubId);
		},
		//课后练习分类选择后更新table数据
		afterSelectSpeSubId(type,selectSpeSubId){
			this.getAfterClassData(type,selectSpeSubId);
		},
		//试卷信息选择弹窗关闭
		afterClassBoxClosed(){
			this.afterClassBox = false;
			this.selectSpeSubId = 0; //=============================分类清空
			this.afterClassPageNo = 1;
			this.afterClassTotal = 0;
		},
		//清空已选择的课后练习
		afterClassSelectClear(){
			this.afterClassData = [];
		},
		//========================================================课后练习&试题测验选择弹窗【结束】=======================================================
		//========================================================试题测验选择弹窗【开始】Exam test=======================================================
		//清空已选择的试题测验
		examTestSelectClear(){
			this.examTestData = [];
		},
		//试题测验选择弹窗
		examTestSelect(type){
			this.examTestBox = true;
			this.getAfterClassData(type,this.selectSpeSubId);
		},
		//试题测验选择弹窗关闭
		examTestBoxClosed(){
			this.examTestBox = false;
			this.selectSpeSubId = 0; //=============================分类清空
			this.examTestPageNo = 1;
			this.examTestTotal = 0;
		},
		//素材选择 单行 checkbox 选中出发
		examTestHandleSelect(selection, row){
			this.examTestData = selection;
		},
		examTestGetRowKey(row){
			return row.id;
		},
		examTestHandleSelectAll(selection){
			this.examTestData = selection;
		},
		//列表分页
		examTestCurrentChange(pageNo){
		    this.examTestPageNo = pageNo;
		    this.getAfterClassData(2,this.selectSpeSubId);
		},
		//试题测验分类选择后更新table数据
		examTestSelectSpeSubId(type,selectSpeSubId){
			this.getAfterClassData(type,selectSpeSubId);
		},
		//========================================================试题测验选择弹窗【结束】Exam test=======================================================
		//试卷table获取数据
		getAfterClassData(type,speSubId) {
			if(type == 1){
				var pageNum = this.afterClassPageNo;
				var limitNum = this.afterClassLimit;
			}else{
				var pageNum = this.examTestPageNo;
				var limitNum = this.examTestLimit;
			}
			this.$post('/admin/examinaList', {
				spe_sub_id:speSubId,
				type:type,
				page:pageNum,
				statue:1,
				limit: limitNum
			}).then((res) => {
				if (res) {
					if(type == 1){
						this.afterClassSelectData = res.data.listInfo;
						this.$nextTick(() => {
							 this.$refs.afterClassMultipleTable.clearSelection();// 清除当前选择状态
						    if (this.afterClassData) { // 如果之前有选中项，重新设置选择状态
						        this.afterClassData.forEach(row => {
						            this.$refs.afterClassMultipleTable.toggleRowSelection(row, true); // 重新设置选择状态为 true
						        });
						    }
						});
						this.afterClassTotal = res.data.all_info_num
					}else{
						this.examTestSelectData = res.data.listInfo;
						this.$nextTick(() => {
							 this.$refs.examTestMultipleTable.clearSelection();// 清除当前选择状态
						    if (this.examTestData) { // 如果之前有选中项，重新设置选择状态
						        this.examTestData.forEach(row => {
						            this.$refs.examTestMultipleTable.toggleRowSelection(row, true); // 重新设置选择状态为 true
						        });
						    }
						});
						this.examTestTotal = res.data.all_info_num
					}
				}	
			}).catch((error) => {
				console.log(error)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.userList {
	height: 100%;

	.img-header {
		width: 60px;
		height: 60px;
		border-radius: 50%;
	}
	.upload-container {
		max-width: 600px;
		padding: 20px;
		border: 1px solid #ebeef5;
		border-radius: 4px;
	}
}
</style>
